/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($) {
    'use strict';
    var $layouts = $('.js-layout-manager');
    if ($layouts.length > 0) {
        $layouts.each(function () {
            $(this).layoutManager({});
        });
    }

    $('[name="ID_LAYOUT"]').change(function (e) {
        var $selector = $(this);
        e.stopImmediatePropagation();
        $('<div>')
            .html($selector.attr('data-confirm'))
            .dialog({
                modal: true,
                close: function() {
                    $selector.val($('[selected]', $selector).val());
                },
                buttons: [{
                    text: LOCALE_BO.layout.confirm['continue'],
                    click: function () {
                        var $saisieObjet = $('#saisie_objet');
                        $saisieObjet.validate().cancelSubmit = true;
                        $saisieObjet.find('input[name=ACTION]').val('CHANGER_LAYOUT');
                        $saisieObjet.submit();
                    }
                }, {
                    text: LOCALE_BO.layout.confirm.cancel,
                    click: function () {
                        $(this).dialog('close');
                    }
                }],
                title: LOCALE_BO.layout.confirm.title
            });
    });

    $( document ).ready(function() {
        $('.js-layout-manager').addClass("layout-manager--loaded");
    });

})(jQuery);
